import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TourStep } from './tour.service';
import { TourConfigService } from './tour-config.service';

@Injectable({
  providedIn: 'root'
})
export class DynamicTourService implements OnDestroy {
  private currentRoute: string = '';
  private routerSubscription?: Subscription;

  constructor(
    private router: Router,
    private tourConfigService: TourConfigService
  ) {
    this.routerSubscription = this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
      this.routerSubscription = undefined;
    }
  }


  getTourStepsForCurrentRoute(): TourStep[] {
    const route = this.currentRoute.toLowerCase();

    if (route.includes('/boards')) {
      return this.tourConfigService.getBoardsTourSteps();
    } else if (route.includes('/work-area')) {
      return this.tourConfigService.getWorkAreaDraftTourSteps();
    } else if (route.includes('/calendar')) {
      return this.getCalendarTourSteps();
    } else {
      return this.tourConfigService.getDashboardTourSteps();
    }
  }


  getTourTitleForCurrentRoute(): string {
    const route = this.currentRoute.toLowerCase();

    if (route.includes('/boards')) {
      return 'Boards Tour';
    } else if (route.includes('/work-area')) {
      return 'Work Area Tour';
    } else if (route.includes('/calendar')) {
      return 'Calendar Tour';
    } else {
      return 'Dashboard Tour';
    }
  }


  getTourIconForCurrentRoute(): string {
    const route = this.currentRoute.toLowerCase();

    if (route.includes('/boards')) {
      return 'layout-grid';
    } else if (route.includes('/work-area')) {
      return 'briefcase';
    } else if (route.includes('/calendar')) {
      return 'calendar';
    } else {
      return 'help-circle';
    }
  }

  private getCalendarTourSteps(): TourStep[] {
    return [
      {
        id: 'calendar-welcome',
        title: 'Congress Calendar',
        text: 'Welcome to the Congress Calendar! Here you can view and manage congressional activities.',
        element: '#congress-calendar',
        position: 'bottom'
      },
      {
        id: 'month-view',
        title: 'Month View',
        text: 'Browse activities by month. Navigate through different months to see historical data.',
        element: '#month-view',
        position: 'bottom'
      },
      {
        id: 'activity-details',
        title: 'Activity Details',
        text: 'Click on any activity to view detailed information about congressional events.',
        element: '#activity-details',
        position: 'left'
      }
    ];
  }


  hasTourForCurrentRoute(): boolean {
    const route = this.currentRoute.toLowerCase();
    return route.includes('/dashboard') ||
      route.includes('/boards') ||
      route.includes('/work-area') ||
      route.includes('/calendar') ||
      route === '/';
  }
}
